export function gallerySlider() {
    const slider = $(".gallery");

    function sliderInit() {
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            mobileFirst: true,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            centerMode: true,
            variableWidth: true,
            outerEdgeLimit: true,
        });
    }

    sliderInit();
}


// WEBPACK FOOTER //
// ./assets/js/modules/gallerySlider.js